// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { datePickerDropDownHandler } from '@shared/utils/AppHandlers';
import TerceraDatePickerDropDownTemplate from '@front/templates/TerceraDatePickerDropDownTemplate.html';
import { ContainerControl } from '../ContainerControl';
import { ControlsTypes } from '../../UtilsClasses/FactoryConstants';
import { generateDateTimePickerLocalization } from './DateTimePickerLocalization';
import { ControlsUtils } from '../../UtilsClasses/ControlsUtils';
export class TerceraDatePickerDropDown extends ContainerControl {
    constructor() {
        super(...arguments);
        this.calendar = null;
    }
    getType() {
        return ControlsTypes.TerceraDatePickerDropDown;
    }
    oncomplete() {
        super.oncomplete();
        this.onDateChanged = this.onDateChanged.bind(this);
        this.calendar = this.Controls.dtpicker;
    }
    onDateChanged(formattedDate, date) {
        if (!isNullOrUndefined(this.callback)) {
            this.callback(date);
        }
        this.Hide();
    }
    Show(date, callback, x, y, additionalParams, closeCallback) {
        const { picker } = this.calendar;
        picker.view = 'days';
        const dateCpy = new Date(date.getTime());
        picker.date = dateCpy;
        picker.selectDate(dateCpy);
        picker.update('minDate', (additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.minDate) || '');
        picker.update('maxDate', (additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.maxDate) || '');
        this.callback = callback;
        void this.set('closeCallback', closeCallback);
        picker.update('onSelect', this.onDateChanged);
        picker.show();
        const datePickerEl = this.find('.date-picker-drop-down');
        const datePickerElRect = datePickerEl.getBoundingClientRect();
        const newCoord = ControlsUtils.CorrectPopupLocation(new Rectangle(x, y, datePickerElRect.width, datePickerElRect.height), null);
        void this.set({ left: newCoord.newX, top: newCoord.newY, visible: true });
    }
    localize() {
        if (!this.calendar)
            return;
        const localization = Object.assign(Object.assign({}, generateDateTimePickerLocalization()), { firstDay: 1 });
        this.calendar.picker.update(localization);
    }
    Hide() {
        void this.set('visible', false);
        this.calendar.picker.update('onSelect', null);
        delete this.callback;
        this.calendar.picker.hide();
        const closeCallback = this.get('closeCallback');
        if (!isNullOrUndefined(closeCallback)) {
            closeCallback();
            void this.set('closeCallback', null);
        }
    }
    static DatePickerDropDownHandlerInitialize() {
        datePickerDropDownHandler.Init = () => {
            const _datePickerDropDown = new TerceraDatePickerDropDown();
            Object.assign(datePickerDropDownHandler, {
                get: (key) => _datePickerDropDown.get(key),
                Hide: _datePickerDropDown.Hide.bind(_datePickerDropDown),
                Show: _datePickerDropDown.Show.bind(_datePickerDropDown),
                localize: _datePickerDropDown.localize.bind(_datePickerDropDown)
            });
        };
    }
}
ContainerControl.extendWith(TerceraDatePickerDropDown, {
    el: '#datePickerDropDownContainer',
    template: TerceraDatePickerDropDownTemplate,
    data: () => ({ visible: false })
});
